import { RecordByPrimaryKey } from "@pdfking/templates"

import type { JobDestinationExt } from "#internal"
import type { DestinationID } from "#public"

import { CMYK } from "../utils/CMYK"

/** Default file destination (python PRINT_DESTINATION.pk). */
export const PRINT_DESTINATION_ID = "a1" as DestinationID
export const PANTONE_DESTINATION_ID = "a5" as DestinationID
export const HOT_FOIL_DESTINATION_ID = "h1" as DestinationID
export const SCREEN_PRINT_DESTINATION_ID = "s1" as DestinationID
export const UV_DESTINATION_ID = "v1" as DestinationID
export const LAMINATION_DESTINATION_ID = "p1" as DestinationID
export const DIE_CUT_DESTINATION_ID = "f1" as DestinationID

// Mirrors python file_destination_list
// (pdfengine/imposition/objects/destination/library.py). Keyed by the
// FileDestination pk so `job_destination` indexes it directly.
export const JobDestinationList = RecordByPrimaryKey<JobDestinationExt>([
  {
    id: PRINT_DESTINATION_ID,
    file_name: "print",
    name: "PRINT",
    print_mode: "print",
  },
  {
    id: PANTONE_DESTINATION_ID,
    file_name: "pantone",
    name: "PANTONE",
    print_mode: "overlay",
    // gold, a shade deeper than the hot foil's
    print_color: CMYK(0, 0.25, 0.75, 0.2, 1),
    print_roughness: 1.0,
  },
  {
    id: HOT_FOIL_DESTINATION_ID,
    file_name: "hot-foil",
    name: "HOT_FOIL",
    print_mode: "overlay",
    print_color: CMYK(0, 0.2, 0.8, 0, 1),
  },
  {
    id: SCREEN_PRINT_DESTINATION_ID,
    file_name: "screen-print",
    name: "SCREEN_PRINT",
    print_mode: "overlay",
    print_color: CMYK(1, 0, 0, 0, 1),
  },
  {
    id: UV_DESTINATION_ID,
    file_name: "uv",
    name: "UV",
    print_mode: "overlay",
    print_color: CMYK(0, 0, 0, 0.5, 0.2),
    guide_color: CMYK(1, 0, 0, 0, 1),
  },
  {
    id: LAMINATION_DESTINATION_ID,
    file_name: "plastica",
    name: "LAMINATION",
    print_mode: "coating",
    print_color: CMYK(0.3, 0, 0, 0, 0.3),
    print_roughness: 0.3,
  },
  {
    id: DIE_CUT_DESTINATION_ID,
    file_name: "fustella",
    name: "DIE_CUT",
    print_mode: "overlay",
    print_color: CMYK(0, 1, 0, 0, 0.5),
  },
] as const)
